function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AppContext } from 'context';
// import CheckCircle from 'svg/check-circle.svg';
import Statement from 'components/Statement';
import messages from '../../messages';
import styles from '../messagePage.pcss';
var _React_PureComponent;
class SignOutSuccessStatement extends (_React_PureComponent = React.PureComponent) {
    get signInUrl() {
        return this.context.getUrl('login');
    }
    // get headerIcon() {
    //   return <CheckCircle className={styles.headerIcon} />;
    // }
    //
    //
    // get messageHeader() {
    //   return <FormattedMessage {...messages.headers.seeYouLater} />;
    // }
    get messageDetails() {
        const clickHereToSignInAgain = (chunk)=>/*#__PURE__*/ _jsx("a", {
                href: this.signInUrl,
                children: chunk
            });
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.loggingOutSuccessful), {
            values: {
                clickHereToSignInAgain
            }
        }));
    }
    render() {
        return /*#__PURE__*/ _jsx(Statement, {
            headerMessage: messages.headers.seeYouLater,
            imgSrc: "/bo/assets/svg/illustration/logout.svg",
            withIcon: "success",
            children: this.messageDetails
        });
    }
}
_define_property(SignOutSuccessStatement, "contextType", AppContext);
export default withStyles(styles)(SignOutSuccessStatement);
